var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLab = function SvgLab(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.789 12.876q.105.168.158.344t.053.374q0 .292-.113.55a1.4 1.4 0 0 1-.769.746q-.264.11-.565.11H1.447a1.45 1.45 0 0 1-1.334-.857 1.35 1.35 0 0 1-.113-.55q0-.197.045-.373.053-.176.158-.344L4.492 5.61a.4.4 0 0 0 .075-.249V.938h-.965V0H9.39v.938h-.964V5.36q0 .14.075.257zM5.532 5.361q0 .389-.204.725l-2.494 4.227h7.325L7.664 6.086a1.4 1.4 0 0 1-.203-.725V.938H5.53zm6.021 8.702q.195 0 .332-.14a.44.44 0 0 0 .143-.33.3.3 0 0 0-.023-.124.4.4 0 0 0-.053-.117l-1.235-2.102H2.275l-1.244 2.102a.45.45 0 0 0-.067.242q0 .19.135.33a.48.48 0 0 0 .347.139z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLab);
export { ForwardRef as ReactComponent };